/**
 * @flow
 *
 * @format
 */

import React from 'react';
import cc from 'classcat';
import _ from 'lodash';

import { StepState } from '~/utils/constants';
import { createSVGMarkup, isBrowserIE } from '~/utils';
import { getStepDataByKey } from '~/utils/stepHelpers';
import Circle from '../Circle';
import classes from './StepGroup.scss';

type PropsType = {
  active: boolean,
  calcOffset: (id: string) => number,
  config: {
    BASE_HEIGHT: number,
    RECT_HEIGHT: number,
    TEXT_HEIGHT: number,
  },
  getIndex: (id: string) => number,
  id: string,
  onClickHandler: (id: string) => any,
  status: string,
};

type StateType = {
  data: StepData,
  index: number,
  offset: number,
};

export class StepGroup extends React.PureComponent<PropsType, StateType> {
  static defaultProps = {
    offset: 0,
    calcOffset: () => 0,
    getIndex: () => 0,
    config: {
      BASE_HEIGHT: 0,
      RECT_HEIGHT: 0,
      TEXT_HEIGHT: 0,
    },
    status: '',
    id: 'STEP_ONE',
  };
  state: StateType; // eslint-disable-line react/sort-comp
  props: PropsType; // eslint-disable-line react/sort-comp

  onClick: () => void;

  // eslint-disable-next-line react/sort-comp
  constructor(props: PropsType) {
    super(props);

    this.state = {
      offset: props.calcOffset(props.id),
      index: props.getIndex(props.id),
      data: getStepDataByKey(props.id),
    };

    this.onClick = () => props.onClickHandler(props.id);
  }

  render() {
    const { config, active, status } = this.props;
    const { id, name, icon } = this.state.data;

    const isComplete = status === StepState.COMPLETE;
    const isDisabled = status === StepState.DISABLED;
    const hasError = status === StepState.ERROR;
    const clickHandler = isDisabled ? _.noop() : this.onClick;

    return (
      <svg
        key={id}
        className={classes.svg}
        x={`${this.state.offset + 0.5}%`}
        width="70"
        onClick={clickHandler}
      >
        <g
          style={{
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            // transform: `translate(-${this.state.offset}%, 0, 0)`,
          }}
          transform="translate(-35, 0)"
        >
          <Circle
            cx={config.BASE_HEIGHT / 2}
            cy={config.BASE_HEIGHT / 2}
            r={(config.BASE_HEIGHT - 2) / 2}
            className={cc({
              [classes.largeCircle]: true,
              [classes.completeRing]: isComplete && !hasError,
              [classes.errorRing]: hasError,
            })}
          />
          <Circle
            cx={config.BASE_HEIGHT / 2}
            cy={config.BASE_HEIGHT / 2}
            r={(config.BASE_HEIGHT - 2) / 2.5}
            className={cc({
              [classes.smallCircle]: true,
              [classes.error]: hasError,
              [classes.active]: active && !hasError,
              [classes.complete]: isComplete && !hasError,
              [classes.disabled]: isDisabled && !hasError,
            })}
          />
          {icon && icon.length > 0 ? (
            <g
              className={classes.svgIcon}
              transform={`translate(${config.BASE_HEIGHT / 2 -
                8}, ${config.BASE_HEIGHT / 2 - 8})`}
            >
              {createSVGMarkup(icon)}
            </g>
          ) : (
            <text
              textAnchor="middle"
              y={config.BASE_HEIGHT / 2 + (isBrowserIE() ? 5 : 0)}
              x={config.BASE_HEIGHT / 2}
              color="black"
              alignmentBaseline="central"
              dominantBaseline="central"
            >
              {this.state.index}
            </text>
          )}
          <text
            className={cc({
              [classes.nameText]: true,
              [classes.activeText]: active,
            })}
            textAnchor="middle"
            y={config.BASE_HEIGHT + config.TEXT_HEIGHT / 2}
            x={config.BASE_HEIGHT / 2}
            alignmentBaseline="central"
            dominantBaseline="central"
          >
            {name}
          </text>
        </g>
      </svg>
    );
  }
}

export default StepGroup;



// WEBPACK FOOTER //
// ./src/components/StepGroup/StepGroup.js